




























































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Achat, EssenceAchat} from '@/models';

import storeAchat from '@/stores/modules/achat';
import storeEssenceAchat from '@/stores/modules/essenceAchat';

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudFournisseurSearch from "@/components/Crud/Fournisseur/Search.vue";
import CrudLongueursAchatSearch from "@/components/Crud/LongueursAchat/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursAchat from "@/components/Input/LongueursAchat.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";
import storeVente from "@/stores/modules/vente";
import CrudEssenceAchatListNew from "@/components/Crud/EssenceAchat/ListNewEssenceAchat.vue";

@Component({
	components: {
		CrudTransporteurSearch,
		CrudFournisseurSearch,
		CrudLongueursAchatSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputLongueursAchat,
		InputDatePicker,
		CrudEssenceAchatListNew,
	}
})
export default class CrudAchatEdit extends AbstractEditVue<Achat> {

	// DF: utiliser pour la création d'un achat uniquement
	// en modification on passe par la light
	private step: number = 0;
	private savedisabled: Boolean = true;
	private essence_achat = null;

	private editEssenceAchat: EssenceAchat = null;
	private storeAchat = storeAchat
	private storeEssenceAchat = storeEssenceAchat

	public constructor() {
		super(
			storeAchat,
			'Achat modifié',
			'Achat créé',
		);
	}

	@Emit()
	private async onNext(): Promise<void> {
		const item = await storeAchat.dispatch('get', this.essence_achat.id);
		this.essence_achat = item
		this.step++
	}

	@Emit()
	private onPrev() {
		this.step--
	}

	private async updateAchat(): Promise<void> {
		const item = await storeAchat.dispatch('get', this.essence_achat.id);
		this.essence_achat = item
	}


	public watcher(): void {
		if (this.item)
		{
			if (!this.item.fournisseur)
			{
				this.savedisabled = true;
			}
			else
			{
				this.savedisabled = false;
			}
		}
	}

//	@Emit()
//	private onNext() {
//		if ((!this.item.address) || (this.item.address === null) )
//		{
//			this.item.address = this.item.name;
//		}
//		this.step = 2;
//	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 0;
	}

	public async mounted(): Promise<void> {
		await storeAchat.dispatch('getAll');
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		this.watcher();
		//console.log('route achat edit-livraison = ' + this.$route.name);
		if (this.$route.name === 'achat-edit-livraison') {
			this.$route.meta.title = 'Modification  d\'un achat';
		}
	}

}
